<template>
  <div class="max-w-5xl mx-auto mt-5">
    <ui-save-bar id="my-save-bar">
      <button
        variant="primary"
        id="save-button"
        @click="onSaveBarSaveClicked"
      ></button>
      <button id="discard-button" @click="onSaveBarDiscardClicked"></button>
    </ui-save-bar>
    <div
      class="bg-white shadow sm:rounded-lg mx-8 mt-8"
      v-if="config.shareButton"
    >
      <div class="py-5 sm:p-6">
        <h3
          class="text-lg leading-6 font-medium text-gray-900"
          id="renew-headline"
        >
          Whatsapp Share
        </h3>
        <div class="mt-2 sm:flex sm:items-start sm:justify-between">
          <div class="max-w-xl text-sm leading-5 text-gray-500">
            <p id="renew-description">
              Enable or Disable WhatsApp Share button on your store
            </p>
          </div>
          <div
            class="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
          >
            <VSwitch
              :value="config.shareButton.isEnabled"
              @input="handleSwitch"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="mx-8" v-if="config.shareButton && config.shareButton.isEnabled">
      <ShareConfigureForm :config="config" @save="updateConfig" />
      <!-- <OnlineStore2Support class="mb-20" /> -->
    </div>
    <Notification :text="notificationText" :show="showNotification" />
    <EmbedBlockModal
      v-if="showEmbedModal"
      description="The WhatsApp share button is not on your theme yet. Add the embed block so it can appear on your storefront."
      @close="showEmbedModal = false"
    />
  </div>
</template>

<script>
import ShareConfigureForm from "../components/Common/ShareConfigureForm";
import Notification from "../components/Common/Notification";
import VSwitch from "../components/Common/VSwitch";
import EmbedBlockModal from "../components/Common/EmbedBlockModal";
import { cloneDeep, isEqual } from "lodash-es";
import crispNudgeMixin from "../Mixins/crispNudgeMixin";

export default {
  name: "Share",
  mixins: [crispNudgeMixin],
  components: {
    ShareConfigureForm,
    Notification,
    VSwitch,
    EmbedBlockModal
  },
  data() {
    return {
      config: {},
      originalConfig: {},
      notificationText: "",
      showNotification: false,
      saveBar: null,
      showEmbedModal: false
    };
  },
  watch: {
    config: {
      deep: true,
      handler() {
        this.checkForChanges();
      }
    }
  },
  created() {
    this.init();
  },
  mounted() {
    this.saveBar = document.getElementById("my-save-bar");
  },
  methods: {
    async init() {
      const response = await this.$store.dispatch("getChatConfig");
      this.config = response.config;
      this.originalConfig = cloneDeep(response.config);
    },
    checkForChanges() {
      if (!isEqual(this.config, this.originalConfig)) {
        this.saveBar.show();
      } else {
        this.saveBar.hide();
      }
    },
    onSaveBarSaveClicked() {
      this.updateConfig();
      this.saveBar.hide();
    },
    onSaveBarDiscardClicked() {
      this.config = cloneDeep(this.originalConfig);
      this.originalConfig = cloneDeep(this.config);
      this.saveBar.hide();
    },
    updateConfig() {
      console.log(this.config);
      const chatConfig = { ...this.config };
      delete chatConfig.scriptTagId;
      delete chatConfig.isEnabled;
      this.$store
        .dispatch("updateChatConfig", { requestParams: chatConfig })
        .then(() => {
          this.displayNotification("settings updated");
          this.originalConfig = cloneDeep(this.config);
          this.showShareSettingsSavedNudge();
        });
    },
    showShareSettingsSavedNudge() {
      this.showCrispNudge({
        key: "share_settings_saved",
        text:
          "Share settings saved! Need help verifying the share button looks right on your store?",
        cooldownMs: 24 * 60 * 60 * 1000,
        scopeToRoute: true
      });
    },
    handleSwitch(value) {
      //   this.config.shareButton.isEnabled = value;
      if (value) {
        this.activateShare();
        return;
      }
      this.deactivateShare();
    },
    activateShare() {
      this.$store.dispatch("activateShare").then(response => {
        if (response.authUrl) {
          if (window.top) {
            window.top.location = response.authUrl;
          } else {
            window.location.href = response.authUrl;
          }
        } else {
          this.config = response.config;
          this.originalConfig = cloneDeep(this.config);
          this.displayNotification("share enabled");

          if (response.isWidgetInstalled === false) {
            this.showEmbedModal = true;
          }
        }
      });
    },
    deactivateShare() {
      this.$store.dispatch("deactivateShare").then(response => {
        this.config = response.config;
        this.originalConfig = cloneDeep(this.config);
        this.displayNotification("share disabled");
      });
    },
    displayNotification(text) {
      this.showNotification = true;
      this.notificationText = text;
      setTimeout(() => {
        this.showNotification = false;
      }, 3000);
    }
  }
};
</script>

<style lang="scss" scoped></style>
